import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { fa } from "vuetify/iconsets/fa";
// make sure to also import the coresponding css
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { mdi } from "vuetify/iconsets/mdi";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#408CCF",
          secondary: "#4599E2",
          accent: "#7CB8E3",
        },
      },
    },
  },
  icons: {
    defaultSet: "mdi",
    sets: {
      mdi,
      fa,
    },
  },
});

createApp(App).use(router).use(vuetify).mount("#app");
